import React from 'react';
import { connect } from 'react-redux';

import { logout, setPasswordRequest } from '../../Networking';
import { passwordChanged } from '../../state/Login';
import '../register/Register.scss';
import './SetPassword.scss';
import olerexLogo from '../assets/Olerex_Logo.svg';
import iconChevronYellowRight from '../dashboard/assets/Icon_Chevron_Yellow-Right.svg';

const PasswordField = React.memo(props =>
    <div className="register_text-field">
        <label className="register_text-field-label" htmlFor={props.id}>{props.label}</label>
        <input className="register_text-field-text" id={props.id} type="password" value={props.value}
            onChange={props.onChange} onKeyDown={props.onKeyDown} size="1" autoComplete="new-password" />
    </div>
);

// Accounts Olerex creates for a company start on a temporary password. The dashboard
// stays behind this until the user picks their own — the same rules the backend enforces
// in olerexweb.setPassword are mirrored here only to disable the button early.
class SetPassword extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { password: "", password2: "", saving: false, error: "" };
    }

    handleFieldChange = (e) => {
        this.setState({ [e.target.id]: e.target.value, error: "" });
    }

    handleKeyDown = (e) => {
        if (e.key === 'Enter' && !this.saveDisabled()) {
            this.doSave();
        }
    }

    saveDisabled = () => {
        const { password, password2, saving } = this.state;

        return saving
            || password.length < 8
            || password !== password2
            || !/[A-Z]/.test(password)
            || !/[0-9]/.test(password);
    }

    doSave = () => {
        if (this.state.saving) {
            return;
        }

        this.setState({ saving: true, error: "" }, () => {
            // request() routes any non-200 statusCode to the error callback, so success
            // here already means the password was accepted.
            this.props.setPassword(
                { password: this.state.password, password2: this.state.password2, language: this.props.language },
                () => this.props.passwordChanged(),
                data => {
                    const records = data && data.records;
                    this.setState({ saving: false, error: (records && records.result) || "" });
                });
        });
    }

    render() {
        return (
            <div className="setpassword-modal">
                <div className="setpassword">
                    <div className="setpassword-logo">
                        <img className="header-logo" src={olerexLogo} alt="" />
                    </div>
                    <div className="setpassword-card">
                        <h1 className="register-title">{this.props.translation.title}</h1>
                        <p className="register-card-top_text">{this.props.translation.info}</p>
                        <div className="setpassword-fields">
                            <PasswordField {...{
                                id: "password",
                                label: this.props.translation.passwordField,
                                value: this.state.password,
                                onChange: this.handleFieldChange,
                                onKeyDown: this.handleKeyDown
                            }} />
                            <PasswordField {...{
                                id: "password2",
                                label: this.props.translation.password2Field,
                                value: this.state.password2,
                                onChange: this.handleFieldChange,
                                onKeyDown: this.handleKeyDown
                            }} />
                        </div>
                        <p className="setpassword-note">{this.props.translation.requirements}</p>
                        {this.state.error && <p className="setpassword-error">{this.state.error}</p>}
                        <div className="setpassword-actions">
                            <button className="setpassword-logout" onClick={() => this.props.logout(this.props.login)}>
                                {this.props.translation.logoutButton}
                            </button>
                            <button className="register-modal_join-button" disabled={this.saveDisabled()} onClick={this.doSave}>
                                <span className="register-modal_join-button_text">{this.props.translation.saveButton}</span>
                                <img className="register-modal_join-button_img" src={iconChevronYellowRight} alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        login: state.login,
        translation: state.translation.setPassword,
        language: (state.login.privateClientData && state.login.privateClientData.language) || state.login.language || 'et',
    }),
    dispatch => ({
        setPassword: (body, success, error) => setPasswordRequest(dispatch, body, success, error),
        passwordChanged: () => dispatch(passwordChanged()),
        logout: (login) => logout(dispatch, login)
    }))(SetPassword);
